import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, Calendar, Shield, Edit, Divide } from 'lucide-react';
import StatusBadge from '../../shared/StatusBadge';

const ProfileHeader = ({ user }) => {
    return (
        <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            className="bg-white p-6 rounded-xl shadow-sm border border-gray-200"
        >
            <div className="flex flex-col sm:flex-row gap-6">
                <img src={"https://avatar.iran.liara.run/public/41"} alt={user.name} className="w-24 h-24 rounded-full" />
                <div className="flex-1">
                    <div className="flex flex-col sm:flex-row justify-between sm:items-start">
                        <div>
                            <h1 className="text-3xl font-bold font-display text-gray-800 capitalize">{user.name} </h1>
                            <h5>{user.member_id}</h5>

                        </div> <div className="mt-1">
                            <StatusBadge status={user.status} />
                        </div>
                        {/* <button className="flex items-center gap-2 px-4 py-2 mt-4 sm:mt-0 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 text-sm font-medium">
                            <Edit size={16} /> Edit Profile
                        </button> */}
                    </div>
                    <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-sm text-gray-600">
                        <div className="flex items-center gap-2">
                            <Mail size={16} className="text-gray-400" />
                            <span>{user.email}</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <Phone size={16} className="text-gray-400" />
                            <span>{user.phone}</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <Shield size={16} className="text-gray-400" />
                            <span className='capitalize'>{user.role}</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <Calendar size={16} className="text-gray-400" />
                            <span>DOB {new Date(user?.meta?.dob).toLocaleDateString()}</span>
                        </div>
                    </div>
                     
                    <div className="mt-4 pt-4 border-t grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-sm text-gray-600">
                        <div className="">
                            <div className={'text-gray-500'}>Address</div>
                            <span className="font-semibold text-black">{user?.meta?.address ?? '--'}</span>
                        </div>
                        <div className="">
                            <div className={'text-gray-500'}>Height</div>
                            <span className="font-semibold text-black">{user?.meta?.height_cm ?? '--'}</span>
                        </div>
                        <div className="">
                            <div className={'text-gray-500'}>Weight</div>
                            <span className="font-semibold text-black">{user?.meta?.weight_kg ?? '--'}</span>
                        </div>
                        <div className="">
                            <div className={'text-gray-500'}>Emergency Contact Name </div>
                            <span className="font-semibold text-black">{user?.meta?.emergency_contact_name ?? '--'}</span>
                        </div>
                        <div className="">
                            <div className={'text-gray-500'}>Emergency Contact Number</div>
                            <span className="font-semibold text-black">{user?.meta?.emergency_contact_number ?? '--'}</span>
                        </div>
                        <div className="">
                            <div className={'text-gray-500'}>Fitness Level</div>
                            <span className="font-semibold text-black">{user?.meta?.fitness_level ?? '--'}</span>
                        </div>
                        <div className="">
                            <div className={'text-gray-500'}>Fitness Goals</div>
                            <span className="font-semibold text-black">{user?.meta?.fitness_goals ?? '--'}</span>
                        </div>
                        <div className="">
                            <div className={'text-gray-500'}>Medical Conditions</div>
                            <span className="font-semibold text-black">{user?.meta?.medical_conditions ?? '--'}</span>
                        </div>
                        <div className="">
                            <div className={'text-gray-500'}>Assigned Trainer</div>
                            <span className="font-semibold text-black">{user?.trainer?.name ?? "--"}</span>
                        </div>
                    </div>
                </div>
            </div>

        </motion.div>
    );
};

export default ProfileHeader;
